import { ReactElement } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon, IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { AGGridCellRenderParams } from "../types";
import { impactContainer, impactTextWarning } from "./styles_vanilla.css";

export type Props = {
  params: AGGridCellRenderParams;
};

type ImpactDisplay = {
  text: string;
  iconType?: IconType;
  color?: Colors;
  className?: string;
};

const parseImpact = (raw: string): ImpactDisplay => {
  if (raw.trim() === "" || raw === "--") {
    return { text: "--" };
  }

  const value = raw.trim();

  const label = value.split(" ").pop() ?? value;
  if (label === "Blocking") {
    return {
      text: "Blocking",
      iconType: "exclamation-triangle",
      color: Colors.Warning600,
      className: impactTextWarning,
    };
  }

  return { text: value };
};

export const ImpactRenderer = ({ params }: Props): ReactElement | null => {
  if (typeof params.value !== "string") {
    const fallback = parseImpact("--");
    return (
      <Flex alignItems="center" gap={8} className={impactContainer}>
        <Text className={fallback.className}>{fallback.text}</Text>
      </Flex>
    );
  }

  const { text, iconType, color, className } = parseImpact(params.value);

  return (
    <Flex alignItems="center" gap={8} className={impactContainer}>
      {iconType && <Icon type={iconType} variant="outline" color={color} />}
      <Text className={className}>{text}</Text>
    </Flex>
  );
};
